<template>
  <div>
    <div class="row g-1 d-flex align-items-center mb-2">
      <label class="col-auto">{{ label }}</label>
      <b-button
        @click="addItem"
        class="col-auto py-0 px-1 ms-2"
        size="sm"
        variant="outline-secondary"
      >
        <b-icon icon="plus"></b-icon>
      </b-button>
    </div>
    <div v-if="$slots.header">
      <div class="d-flex">
        <div class="flex-grow-1">
          <slot name="header"></slot>
        </div>
        <div class="flex-shrink-0">
          <b-button
            size="sm"
            variant="light"
            class="invisible my-0"
            tabindex="-1"
          >
            <b-icon icon="trash-fill" variant="danger"></b-icon>
          </b-button>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in value" :key="index" class="mb-1">
      <div class="d-flex">
        <div class="flex-grow-1">
          <slot class="d-flex g-1" :item="item" :index="index"></slot>
        </div>
        <div class="flex-shrink-0">
          <b-button
            size="sm"
            variant="light"
            @click="handleRemove(index)"
            tabindex="-1"
          >
            <b-icon icon="trash-fill" variant="danger"></b-icon>
          </b-button>
        </div>
      </div>
    </div>

    <div class="text-danger" v-if="value.length < minItems">
      <small v-if="minItems === 1">Se requiere al menos un elemento</small>
      <small v-else>Se requieren al menos {{ minItems }} elementos</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "List-edit",
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "Lista",
    },
    minItems: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    addItem() {
      this.$emit("handleAdd");
    },
    handleRemove(index) {
      this.$emit("handleRemove", index);
    },
  },
};
</script>
<style scoped>
li {
  font-family: Consolas, monospace;
}
</style>
